import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'directo',
    loadChildren: () => import('./modules/directo/directo.module').then(m => m.DirectoModule)
  }, {
    path: 'freelance',
    loadChildren: () => import('./modules/freelance/freelance.module').then(m => m.FreelanceModule)
  }, {
    path: 'politicas',
    loadChildren: () => import('./modules/politicas-general/politicas-general.module').then(m => m.PoliticasGeneralModule)
  }, {
    path: 'calendario',
    loadChildren: () => import('./modules/calendario/calendario.module').then(m => m.CalendarioModule)
  }, {
    path: 'cambios-de-politicas',
    loadChildren: () => import('./modules/update-policy/update-policy.module').then(m => m.UpdatePolicyModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
